import React from "react";
import PropTypes from "prop-types";

const Timer = ({ seconds }) => {
  return (
    <div className="flex items-center justify-center h-full">
      <div className="text-4xl font-bold font-sans">{seconds}</div>
    </div>
  );
};

Timer.propTypes = {
  seconds: PropTypes.number.isRequired,
};

export default Timer;
